import React from 'react';
import PropTypes from 'prop-types';

const Level = (props) => {
  const title = `level ${props.level}`;

  return (
    <img 
      src={`/images/general/levels/level ${props.level}.png`} 
      title={title}
      alt={title}
      onClick={props.onClick} />
  );
}

Level.propTypes = {
  level: PropTypes.number.isRequired,
  onClick: PropTypes.func
};

Level.defaultProps = {
  onClick: () => {}
}

export default Level